import BigNumber from "bignumber.js";

export const BN_ZERO = new BigNumber(0);
export const BN_ONE = new BigNumber(1);

export const Paths = {
  Landing: {
    Index: "/",
  },
};

export const PUSH_NOTIFICATION_STORAGE_KEY = "push-notification-register-status";
export const REGISTERED = "REGISTERED";

export const LOGIN_URL = "https://a.ntrk2.com/845aab3a-c4c3-4a0a-bfa2-9dd62917db2c";
export const REGISTER_URL = "https://a.ntrk2.com/48dc51ff-47cb-4f56-9ba4-e35575b0d67d";

export const LOGIN_URL_MAP = {};

export const REGISTER_URL_MAP = {};

export const FLOATING_BANNER_URL = "";

export const DOWNLOAD_URL = "https://ganamx.kzw2a.com/download?openExternalBrowser=1&id=xeq7gv1h3y1ieg5";

export * from "./codes";
export * from "./context";
